import moment from "moment";

import type { RewardOffer } from "./types";

export const transformApiOfferToRewardOffer = (
  apiOffer: API.CardOffer,
  targeted: boolean = false,
): RewardOffer => {
  const { assets } = apiOffer;
  const logoAsset = assets.find((asset) => asset.type === "IMG_VIEW");
  const bannerAsset = assets.find((asset) => asset.type === "BANNER_VIEW");

  return {
    id: apiOffer.id,
    name: apiOffer.name,
    description: apiOffer.description,
    terms: apiOffer.terms,
    categories: apiOffer.categories,
    rewardType: apiOffer.reward_type,
    rewardValue: apiOffer.reward_value,
    purchaseChannels: apiOffer.purchase_channels,
    minTransactionAmount: apiOffer.min_transaction_amount,
    maxTransactionAmount: apiOffer.max_transaction_amount,
    minRewardAmount: apiOffer.min_reward_amount,
    maxRewardAmount: apiOffer.max_reward_amount,
    startDate: apiOffer.start_date || "",
    expirationDate: apiOffer.expiration_date || "",
    merchantUrl: apiOffer.merchant_url || "",
    logoUrl: logoAsset?.url,
    bannerUrl: bannerAsset?.url,
    isTargeted: targeted,
  };
};

export const searchAndFilterOffers = (
  offers: RewardOffer[],
  _searchTerm = "",
  selectedOfferCategory = "",
) => {
  const searchTerm = _searchTerm.toLowerCase();
  if (!selectedOfferCategory && !searchTerm) {
    return offers;
  }
  return offers.filter(({ name: _name, categories }) => {
    const name = _name.toLowerCase();
    return (
      (name.startsWith(searchTerm) || name.includes(searchTerm)) &&
      (selectedOfferCategory
        ? categories.includes(selectedOfferCategory)
        : true)
    );
  });
};

export const getOfferExpirationDisplay = (expirationDate: string): string =>
  `Expires ${moment(expirationDate).format("MM/DD")}`;

export const getPurchaseChannelDisplay = (
  channels: RewardOffer["purchaseChannels"],
): string => {
  if (channels.length === 2) {
    return "Online & In-store";
  }
  if (channels.includes("in_store")) {
    return "In-store";
  }
  if (channels.includes("online")) {
    return "Online";
  }
  return "";
};

export const getOfferRewardDisplay = (
  type: RewardOffer["rewardType"],
  value: number,
): string => {
  return type === "flat" ? `$${value / 100}` : `${value / 100}%`;
};

export const getOfferRequirementsDisplay = (offer: RewardOffer): string => {
  const { rewardType, rewardValue, maxRewardAmount, minTransactionAmount } =
    offer || {};
  const rewardDisplay = getOfferRewardDisplay(rewardType, rewardValue);

  const minimumSpendRequirement = minTransactionAmount
    ? ` when you spend at least ${getOfferRewardDisplay("flat", minTransactionAmount)}`
    : "";

  const maxRewardAmountDisplay = maxRewardAmount
    ? ` up to ${getOfferRewardDisplay("flat", maxRewardAmount)}`
    : "";

  return `${rewardDisplay} cash back${maxRewardAmountDisplay}${minimumSpendRequirement}`;
};
